import { Head, router, useForm } from "@inertiajs/react"

import PartnerForm from "@/components/partners/partner-form"
import RecordForm from "@/components/record-form"
import RecordPageHeader from "@/components/ui/record-page-header"
import AdminLayout from "@/layouts/admin-layout"
import { adminPartnersPath, newAdminPartnerPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Partners", href: adminPartnersPath() },
  { title: "New Partner", href: newAdminPartnerPath() },
]

export default function NewPartner() {
  const { data, setData, post, processing, errors } = useForm({
    partner: {
      name: "",
      description: "",
      logo: null as File | null,
      logo_wordmark: null as File | null,
      billing_type: "partner_managed" as
        | "imperative_managed"
        | "partner_managed",
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(adminPartnersPath(), { forceFormData: true })
  }

  function handleCancel() {
    router.visit(adminPartnersPath())
  }

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title="New Partner" />
      <div className="flex h-full w-full flex-col gap-6 p-4">
        <div className="mx-auto w-full max-w-2xl">
          <RecordPageHeader title="New Partner" />
        </div>
        <RecordForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          processing={processing}
        >
          <PartnerForm
            data={data}
            setData={setData}
            errors={errors}
            logoUrl={null}
            logoWordmarkUrl={null}
          />
        </RecordForm>
      </div>
    </AdminLayout>
  )
}
